import {
  setValue,
  setFormatAssignDate,
  setFormatTime,
  setListPreviewImages,
} from 'helpers/common'
import { TASK_EVENT_TYPE } from 'types/enums'

import type {
  IUploadPhoto,
  sourceImage,
  ITaskTransactionProduct,
} from 'features/Ticket'

interface IResponsePhotoContent {
  technicianFullName: string
  uploadPhotoDate: string
  uploadPhotoTime: string
  photoList: sourceImage
}

const getTechnicianFullName = (photos: IUploadPhoto[] | null) => {
  return photos ? setValue(photos[0].createdByName) : '-'
}

const getUploadPhotoDate = (photos: IUploadPhoto[] | null) => {
  return photos ? setFormatAssignDate(new Date(photos[0].createdAt)) : '-'
}

const getUploadPhotoTime = (photos: IUploadPhoto[] | null) => {
  return photos ? setFormatTime(new Date(photos[0].createdAt)) : '-'
}

export const getPhotoContent = (
  photos: IUploadPhoto[] | null,
): IResponsePhotoContent => {
  const technicianFullName = getTechnicianFullName(photos)
  const uploadPhotoDate = getUploadPhotoDate(photos)
  const uploadPhotoTime = getUploadPhotoTime(photos)
  const photoList = setListPreviewImages(photos)

  return {
    technicianFullName,
    uploadPhotoDate,
    uploadPhotoTime,
    photoList,
  }
}

export const getProductPhotos = (
  typeEvent: string,
  product: ITaskTransactionProduct | null,
): IUploadPhoto[] | null => {
  if (!product) {
    return null
  }

  const isBefore =
    typeEvent === TASK_EVENT_TYPE.TASK_PRODUCT_UPLOAD_BEFORE_PHOTOS
  const photos = isBefore ? product.beforePhotos : product.afterPhotos

  return photos || null
}
